import { useSelector } from 'react-redux';
import React from 'react';
import DynamicContainer from '../dynamicComponents/DynamicContainer';
import { createSelector } from '@reduxjs/toolkit';
import {
	selectActiveScene,
	selectRenderScene,
} from '@wsc/redux_stores/sceneLoadReducer';

const selectSceneOverlays = createSelector(
	[
		selectActiveScene,
		selectRenderScene,
		(state) => state.componentConfig || {},
	],
	(activeScene, renderScene, componentConfig) => {
		return {
			sceneOverlay: componentConfig?.[activeScene],
			renderScene,
		};
	},
);

const SceneOverlays = () => {
	const { sceneOverlay, renderScene } = useSelector(selectSceneOverlays);
	console.log('%c SceneOverlays rerendered', 'color:yellow');

	if (sceneOverlay === undefined || Object.keys(sceneOverlay).length === 0) {
		return null;
	}

	const { components } = sceneOverlay;

	return (
		renderScene &&
		components &&
		components.length > 0 && (
			<div className="sceneOverlays">
				<DynamicContainer components={components} />
			</div>
		)
	);
};

export default SceneOverlays;
